import { useAuth } from '@app/core/auth/authentication/hooks';
import { ImpersonationPage } from '@app/core/auth/impersonation';
import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch } from 'react-router-dom';
import { UserSettingsPage } from '../screens/user-settings/UserSettingsPage';

export function SettingsRoutes() {
  const { isSuperadmin, isImpersonated } = useAuth();
  const allowImpersonationRoute = isSuperadmin || isImpersonated;

  return (
    <Switch>
      {allowImpersonationRoute && (
        <AppRoute path={SettingsRoutes.ROUTES.impersonation} component={ImpersonationPage} />
      )}
      <AppRoute exact path="/settings/user" component={UserSettingsPage} />
    </Switch>
  );
}

SettingsRoutes.ROUTES = {
  impersonation: '/settings/impersonation',
  userSettings: '/settings/user',
};
